import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // Redirects de compatibilidade para links de campanha antigos
  { path: '/internet-5g', redirect: to => ({ path: '/', query: to.query }) },
  { path: '/internet-5g/dados-do-contrato', redirect: '/dados-do-contrato' },
  { path: '/internet-5g/documentos', redirect: '/documentos' },
  { path: '/internet-5g/pagamento', redirect: '/revisao' },
  { path: '/internet-5g/revisao', redirect: '/revisao' },
  { path: '/internet-5g/conclusao', redirect: '/conclusao' },
  { path: '/internet-5g/sucesso', redirect: '/sucesso' },
  {
    path: '/sucesso',
    name: 'Success',
    component: () => import('@/views/internet5g/Success'),
    meta: { fullscreen: true }
  },
  {
    path: '/',
    name: 'Availability',
    component: () => import('@/views/Availability')
  },
  {
    path: '/session/:id?',
    name: 'Session',
    component: () => import('@/views/Availability')
  },
  {
    path: '/dados-do-contrato',
    name: 'ContractData',
    component: () => import('@/views/ContractData')
  },
  {
    path: '/portabilidade',
    name: 'Portability',
    component: () => import('@/views/Portability')
  },
  {
    path: '/documentos',
    name: 'Documents',
    component: () => import('@/views/Documents')
  },
  {
    path: '/pagamento',
    name: 'Payment',
    component: () => import('@/views/Payment')
  },
  {
    path: '/instalacao',
    name: 'Installation',
    component: () => import('@/views/Installation')
  },
  {
    path: '/revisao',
    name: 'Revision',
    component: () => import('@/views/Revision')
  },
  {
    path: '/conclusao',
    name: 'Conclusion',
    component: () => import('@/views/Conclusion')
  },
  {
    path: '/suporte',
    name: 'ScheduleYourService',
    component: () => import('@/views/ScheduleYourService')
  }

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  }
})

router.afterEach(() => {
  const el = document.querySelector('.desktop-layout__left-side')
  if (el) {
    el.scrollTo({ top: 0, behavior: 'smooth' })
  }
})

export default router
